export default __webpack_public_path__ + "static/mini-verso-4-5fe06512f7b1d1520c962ada9e06055a.jpg";